export default `float de( vec3 p ) {
  const float phi = ( 1.0 + sqrt( 5.0 ) ) * 0.5;
  const float l = phi*2.;
  p = abs( p );
  float a = max( max( p.x, p.y ), p.z );
  p += ( p + p.yzx ) * phi + p.zxy;
  return max( a, max( p.x, max( p.y, p.z ) ) / l ) - 1.0;
}`